// src/hooks/useIssuanceSocket.js
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addRealtimeMessage,
  updateRealtimeMessage,
  deleteRealtimeMessage,
  setRealtimeTickets,
  clearPendingAcknowledgement,
  setPendingAcknowledgement,
} from "store/slices/ticketSlice"; // ← Add these actions

import {
  clearPendingRequestAck,
  setPendingRequestAck,
  setRealtimeRequests,
} from "store/slices/requestIssuanceSlice";
import {
  clearPendingAssetAssignAck,
  setPendingAssetAssignAck,
  setRealtimeAssetAssigns,
} from "store/slices/assetAssignSlice";

import notificationSoundFile from "assets/voice/notifcation.mp3";

const useIssuanceSocket = () => {
  const dispatch = useDispatch();
  const user = useSelector((s) => s.auth.user);
  const token = localStorage.getItem("token");

  const notificationSound = new Audio(notificationSoundFile);
  notificationSound.volume = 0.6;

  const playSound = () => {
    notificationSound.currentTime = 0;
    notificationSound.play().catch(() => {});
  };

  useEffect(() => {
    if (!token || !user?.id) return;

    const API_SOCKET_URL = process.env.REACT_APP_SOCKET_BASE_URL;
    const wsUrl = `${API_SOCKET_URL}/issuances/?token=${token}`;

    let socket;

    const connect = () => {
      socket = new WebSocket(wsUrl);

      socket.onopen = () => {
        console.log("Issuance WebSocket connected");
      };

      socket.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          console.log("Issuance WS message:", data);

          if (data.type === "initial_state") {
            const {
              tickets = [],
              requests = [],
              asset_assigns = [],
            } = data.data;

            dispatch(setRealtimeTickets(tickets));
            dispatch(setRealtimeRequests(requests));
            dispatch(setRealtimeAssetAssigns(asset_assigns));
          } 
          else if (data.type === "ticket_update") {
            // dispatch(setRealtimeTickets(data.data));
            const ticket = data.data;
            console.log("Received ticket:", data, data.data, ticket);
            dispatch(setRealtimeTickets(ticket));
            if (ticket.status === "ack_pending") {
              dispatch(
                setPendingAcknowledgement({
                  ticketId: ticket.id,
                  data: ticket,
                })
              );
            }

            playSound();
          }
          else if (data.type === "new_ticket") {
            const ticket = data.data;

            // Safe update (handles single object or array)
            dispatch(setRealtimeTickets(ticket));

            // NEW: Open modal when approved → ack_pending
            if (ticket.status === "ack_pending") {
              dispatch(
                setPendingAcknowledgement({
                  ticketId: ticket.id,
                  data: ticket,
                })
              );
            }

            playSound();
          }
           else if (data.type === "ticket_acknowledged") {
            // When someone acknowledges (including yourself), close modal if open
            dispatch(clearPendingAcknowledgement());
            dispatch(setRealtimeTickets(data.data));
            playSound();
          }
          // else if (data.type === "request_update") {
          //   dispatch(setRealtimeRequests(data.data));
          //   // NEW: Open modal when approved → ack_pending
          //   if (request.status === "ack_pending") {
          //     dispatch(
          //       setPendingAssetAssignAck({
          //         id: request.id,
          //         data: request,
          //       })
          //     );
          //   }
          //   playSound();
          // }
          else if (data.type === "request_update") {
            const request = data.data; // ← fix: extract here

            dispatch(setRealtimeRequests(request));

            // Only trigger acknowledgement modal for the CURRENT user
            if (
              request.status === "ack_pending" &&
              request.created_by === user?.id
            ) {
              dispatch(
                setPendingRequestAck({
                  id: request.id,
                  data: request,
                })
              );
            }

            playSound();
          }
          // Inside socket.onmessage
          else if (data.type === "new_request") {
            const request = data.data;

            // Safe update (handles single object or array)
            dispatch(setRealtimeRequests(request));

            // NEW: Open modal when approved → ack_pending
            if (request.status === "ack_pending") {
              dispatch(
                setPendingRequestAck({
                  id: request.id,
                  data: request,
                })
              );
            }

            playSound();
          } else if (data.type === "request_acknowledged") {
            dispatch(clearPendingRequestAck());
            dispatch(setRealtimeRequests(data.data)); // update with latest
            playSound();
          } else if (data.type === "asset_assign_update") {
            dispatch(setRealtimeAssetAssigns(data.data));
            playSound();
          } else if (data.type === "new_asset_assign") {
            const assign = data.data;

            // Update the list (single item update)
            dispatch(setRealtimeAssetAssigns(assign));

            // NEW: If status is ack_pending → open acknowledgement modal
            // if (assign.status === "ack_pending") {
            if (
              assign.status === "ack_pending" &&
              assign.employee_details?.id !== user?.id &&
              assign.created_by !== user?.id
            ) {
              dispatch(
                setPendingAssetAssignAck({
                  id: assign.id,
                  data: assign,
                })
              );
            }

            playSound();
          } else if (data.type === "asset_assign_acknowledged") {
            // Close modal when acknowledged (by anyone, including self)
            dispatch(clearPendingAssetAssignAck());
            dispatch(setRealtimeAssetAssigns(data.data)); // update with latest
            playSound();
          }

            else if (data.type === "asset_assign_returned") {
            // Close modal when acknowledged (by anyone, including self)
            // dispatch(clearPendingAssetAssignAck());
            dispatch(setRealtimeAssetAssigns(data.data)); // update with latest
            playSound();
          }

          // NEW: Handle real-time messages
          // else if (data.type === "ticket_message") {
          //   const { ticket_id, message } = data;
          //   dispatch(addRealtimeMessage({ ticketId: ticket_id, message }));
          //   playSound();
          // } else if (data.type === "ticket_message_update") {
          //   const { ticket_id, message } = data;
          //   dispatch(updateRealtimeMessage({ ticketId: ticket_id, message }));
          // } else if (data.type === "ticket_message_delete") {
          //   const { ticket_id, message_id } = data;
          //   dispatch(
          //     deleteRealtimeMessage({
          //       ticketId: ticket_id,
          //       messageId: message_id,
          //     })
          //   );
          // }
          else if (data.type === "ticket_message") {
  const ticketId = data.object_id;                 // <-- correct field
  const message = data.message_data;               // <-- correct message object

  if (ticketId && message) {
    dispatch(addRealtimeMessage({ ticketId, message }));
    
    // Optional: also update ticket status/details if provided
    if (data.data) {
      dispatch(setRealtimeTickets(data.data));     // reuse your ticket updater
    }

    playSound();
    flashTitle?.(); // if you have flashing
  }
} 
else if (data.type === "ticket_message_update") {
  const ticketId = data.object_id;
  const message = data.message_data;

  if (ticketId && message) {
    dispatch(updateRealtimeMessage({ ticketId, message }));
  }
} 
else if (data.type === "ticket_message_delete") {
  const ticketId = data.object_id;
  const messageId = data.message_data?.id || data.message_id;

  if (ticketId && messageId) {
    dispatch(deleteRealtimeMessage({ ticketId, messageId }));
  }
}
        } catch (err) {
          console.error("Failed to parse issuance WS message:", err);
        }
      };

      socket.onclose = (event) => {
        console.log("Issuance WS closed:", event.code, event.reason);
        setTimeout(connect, 3000);
      };

      socket.onerror = (err) => {
        console.error("Issuance WS error:", err);
      };
    };

    connect();

    return () => {
      if (socket && socket.readyState === WebSocket.OPEN) {
        socket.close();
      }
    };
  }, [user?.id, token, dispatch]);
};

export default useIssuanceSocket;
